import api from './authService'

export const coreService = {
    /**
     * NEW: Dedicated method for "Enhance with AI" operations
     * This is the recommended method for all enhancement features
     */
    async enhance(payload: { content: string; instruction?: string; context?: any }) {
        const response = await api.post('/core/enhance', payload)
        return response.data
    },

    /**
     * Extract project structure from document upload
     */
    async extractFromFile(file: File) {
        const formData = new FormData()
        formData.append('file', file)
        const response = await api.post('/core/extract-file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return response.data
    },

    /**
     * LEGACY: Deprecated, redirects to enhance()
     * @deprecated Use enhance() instead
     */
    async inlineEdit(payload: { content: string; instruction?: string; context?: any }) {
        console.warn('[DEPRECATED] inlineEdit() is deprecated. Use enhance() instead.')
        return this.enhance(payload)
    },

    async getSuggestions(payload: { content: string; type: string; context?: any }) {
        const response = await api.post('/core/suggestions', payload)
        return response.data
    },

    async chat(payload: { message: string; context?: any; conversationId?: string }) {
        const response = await api.post('/core/chat', payload)
        return response.data
    },

    async validateKeywords(keywords: string[]) {
        const response = await api.post('/core/validate-keywords', { keywords })
        return response.data
    }
}
